module.exports = (Type) -> (val, message = "assertion failed") ->
  if !val
    throw new Type(message)
  return



// WEBPACK FOOTER //
// ./app/scripts/lib/assert/er.coffee